const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const storeCustomerAllFields = [
  {
    id: "name",
    label: "Name",
    placeHolder: "Enter full name",
    type: "text",
    isRequired: true,
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly: false,
  },
  {
    id: "referrerId",
    label: "Referrer",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
    isRequired: true,
  },
  {
    id: "phone",
    label: "Mobile Number",
    placeHolder: "Enter phone number",
    type: "contact",
    md: 4,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },

   {
    id: "email",
    label: "Email",
    placeHolder: "Enter email ID",
    type: "text",
    md: 4,
    isRequired: true,
  },
  {
    id: "movingOnDate",
    label: "Moving On",
    placeHolder: "Select",
    type: "daterangebothvalue",
    md: 4,
    disablePast: true,
  },
    {
     id: "alternatePhone",
    label: "Alternate Mobile Number",
    placeHolder: "Enter alternate phone number",
    type: "contact",
    md: 4,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "followUpDate",
    label: "Follow Up",
    placeHolder: "Select",
    type: "date",
    md: 2.5,
    disablePast: true,
  },
  {
    id: "followUpEndDate",
    label: "\u00A0",
    placeHolder: "Select",
    type: "timerange",
    disablePast: true,
    md: 3,
  },
   {
    id: "leadTypeId",
    label: "Lead Type",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
   {
    id: "moveType",
    label: "Lead Type",
    placeHolder: "Select",
    type: "select",
    options: ["Commercial", "Residential", "International"],
    md: 3,
    professionalOnly:false,
  },
  {
    id: "advertId",
    label: "Advert ID",
    placeHolder: "Enter Advert ID",
    type: "text",
    md: 2.5,
    professionalOnly:true,
    // isRequired: true,
  },
  
  {
    id: "promoCode",
    label: "Promotion",
    placeHolder: "Enter Promotion",
    type: "text",
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
  {
    id: "promoSource",
    label: "Promo Source",
    placeHolder: "Enter Promo Source",
    type: "text",
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
   {
    id: "salesPersonId",
    label: "Sales Person",
    // placeHolder: "Enter Sales Person",
    type: "select",
    options:[],
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
 
   {
    id: "isAccount",
    label: "Account",
    placeHolder: "Select",
    type: "radio",
    md: 3,
    professionalOnly:true,
    options: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  },
  {
    id: "accountName",
    label: "Account Name",
    placeHolder: "Enter Account Name",
    type: "suggestionText",
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
  {
    id: "prefix",
    label: "Prefix",
    placeHolder: "Enter Prefix",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    professionalOnly:true,
    // isRequired: true,
  },
];

export const leadCustomerNotesFields = [
  {
    id: "customerNotes",
    label: "",
    placeHolder: "Enter notes",
    type: "text",
    inputProps: {
      maxLength: 250,
    },
    md: 10.5,
  },
];